function initErbatabPressLines() {
  document.querySelectorAll('.press__logo').forEach((logo) => {
    if (logo.querySelector('.erbatab-press-line')) return;

    logo.insertAdjacentHTML(
      'beforeend',
      `<svg class="erbatab-press-line"
        viewBox="0 0 100 18"
        aria-hidden="true">
        <path d="M2 15 Q50 2 98 15"></path>
      </svg>`
    );
  });
}

document.addEventListener('DOMContentLoaded', initErbatabPressLines);
document.addEventListener('shopify:section:load', initErbatabPressLines);